// LiBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Row as AntRow, Typography } from 'antd';

// CONSTANTS
const { Title } = Typography;

function InventoryPageCrumb({ pageTitle }) {
	return (
		<AntRow type="flex" align="middle" justify="start">
			{/* <Title level={4}>{pageTitle}</Title> */}
			<p className="font-lg leading-none leading-botton-0 font-bolder">{pageTitle}</p>
		</AntRow>
	);
}

InventoryPageCrumb.propTypes = {
	pageTitle: PropTypes.string.isRequired,
};

export default InventoryPageCrumb;
